module.exports = __webpack_public_path__ + "static/img/行销-3.af89ac8e.png";